'use strict';

import {invitationModel} from "../../models/invitationmodel.js";
import {responsibleModel} from "../../models/responsiblemodel.js";
import {memberModel} from "@js/models/membermodel";

export class InvitationResponsibleCtrl
{
	$scope;
	$filter;
	jsDataService;
	$mdDialog;
	item = {};
	responsible = [];
	
	constructor($scope, $filter, jsDataService, $mdDialog){
		'ngInject';
		this.$scope = $scope;
		this.$filter = $filter;
		this.jsDataService = jsDataService;
		this.$mdDialog = $mdDialog;
		this.classif = this.jsDataService.get('cfgClassif', {});
		this.item = new invitationModel(jsDataService.get('invitationBase', {}), $filter, jsDataService);
		this.loadResponsible();
	}
	
	loadResponsible(){
		if(this.jsDataService.get('cfgDataUrl')){
			this.promise = this.$scope.basicHttpConfigProcess({
				url: this.jsDataService.get('cfgDataUrl'),
				method: 'GET',
				params: {}
			}).then((response) => {
				if(response.data.success){
					this.setResponsibleData(response.data.data, response.data.members);
				}
			}, () => {});
		}
	}

	setResponsibleData(data, members) {
		this.responsible = {
			application: [],
			invitation: [],
			inform: [],
		};

		this.responsible.inform = members.map(member => new memberModel(member, this.$filter, this.jsDataService));

		for (let row of data) {
			if (row.value === "inform") {
				continue;
			}

			if (typeof this.responsible[row.value] !== 'undefined') {
				this.responsible[row.value].push(new responsibleModel(row, this.$filter, this.jsDataService));
			}
		}
	}


	removeResponsible(ev, responsible){
		if(this.jsDataService.get('cfgRemoveUrl', '') !== ''){
			const confirmTexts = this.jsDataService.get('removeConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgRemoveUrl'),
					method: 'GET',
					responseType: 'json',
					params: {
						id: responsible.id
					}
				}).then((results) => {
					if(results.data.success){
						this.loadResponsible();
					}
				});
			}, () => {});
		}
	}

	removeMember(ev, member){
		if(this.jsDataService.get('cfgRemoveMemberUrl', '') !== ''){
			const confirmTexts = this.jsDataService.get('removeConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgRemoveMemberUrl'),
					method: 'GET',
					responseType: 'json',
					params: {
						id: member.id
					}
				}).then((results) => {
					if(results.data.success){
						this.loadResponsible();
					}
				});
			}, () => {});
		}
	}
	
	editResponsible(ev, responsible){
		this.responsibleEditor(ev, responsible);
	}
	
	addResponsible(ev, typeValue){
		this.responsibleEditor(ev, new responsibleModel({
			id: 0, 
			user_id: 0,
			value: typeValue, 
		}, this.$filter, this.jsDataService));
	}
	
	responsibleEditor(ev, responsible){
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", "$filter", "jsDataService", "responsible", "allmembers", this.responsibleEditorDialogCtrl],
			templateUrl: 'invitations/responsible_editor.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose:true,
			fullscreen: true,
			locals: {
				responsible: responsible,
				allmembers: this.responsible[responsible.value]
			}
		}).then((results) => {
			if (responsible.value === "inform" && this.jsDataService.get('cfgSaveMemberUrl')) {
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgSaveMemberUrl'),
					method: 'POST',
					data: results
				}).then((response) => {
					if (response.data.success) {
						this.loadResponsible();
					}
				}, () => {});
			} else if(this.jsDataService.get('cfgSaveUrl')){
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgSaveUrl'),
					method: 'POST',
					data: results
				}).then((response) => {
					if(response.data.success){
						this.loadResponsible();
					}
				}, () => {});
			}else {
				console.log('No URL provided for saving');
			}
		}, () => {});
	}
	
	responsibleEditorDialogCtrl($scope, $mdDialog, $filter, jsDataService, responsible, allmembers){
		$scope.responsible = angular.copy(responsible);
		$scope.isSearch = (typeof($scope.responsible.id) === 'undefined' || $scope.responsible.id < 1);
		
		
		$scope.userdata = [];
		$scope.searchString;
		
//		if($scope.responsible.value != 'manager'){
//			if(typeof($scope.responsible.term) !== 'undefined' && $scope.responsible.term > 0){
//				$scope.responsible.termDate = new Date($scope.responsible.term * 1000);
//			}
//			else{
//				$scope.responsible.termDate = new Date();
//			}
//		}
//		else{
//			$scope.responsible.termDate = null;
//		}
		
		function getUsers(){
			if(jsDataService.get('cfgUsersUrl')){
				$scope.$root.basicHttpConfigProcess({
					url: jsDataService.get('cfgUsersUrl'),
					method: 'GET',
					params: {
						query: $scope.searchString
					}
				}).then((response) => {
					if(response.data.success){
						setData(response.data.data);
					}
				}, () => {});
			}
		}
		
		function inMembersByUid(userId){
			return ($filter('filter')(allmembers, {user_id: userId}, true).length > 0);
		}

		function inMembersByEmail(email){
			return ($filter('filter')(allmembers, {responsible_email: email}, true).length > 0 || $filter('filter')(allmembers, {email: email}, true).length > 0);
		}
		
		function setData(data){
			$scope.resetResults();
			for(let u of data){
				u.responsible_id = 0;
				u.type = 'user';
				u.user_id = u.id;
				u.responsible = u.name + ' ' + u.lastname + ', ' + u.email;
				u.namelastname = u.name + ' ' + u.lastname;
				u.inlist = (inMembersByUid(u.id) || inMembersByEmail(u.email));
				$scope.userdata.push(u);
			}

			if ($scope.responsible.value === 'inform') {
				if ($scope.userdata.length < 1 && /^.+@.+\..+$/.test($scope.searchString) && !inMembersByEmail($scope.searchString)) {
					let u = {
						responsible_id: 0,
						user_id: 0,
						type: 'email',
						responsible_email: $scope.searchString,
						responsible: $scope.searchString
					};
					$scope.userdata.push(u);
				}
			}
		}
		if($scope.isSearch){
			$scope.$watch("searchString", (nval, oval) => {
				if(typeof(nval) !== 'undefined' && nval !== ''){
					getUsers();
				}
				else{
					$scope.resetResults();
				}
			});
		}
		
		
		$scope.resetResults = function(){
			$scope.userdata = [];
		};
		
		$scope.assignUser = function(user){
			user.actions = ['preview'];
			$scope.responsible.user_id = user.id;
			$scope.responsible.name = user.name;
			$scope.responsible.lastname = user.lastname;
			$scope.responsible.email = user.email;
			$scope.searchString = '';
			if ($scope.responsible.value === 'inform') {
				 $scope.responsible = new responsibleModel(user, $filter, jsDataService);
			}
		};
		
		$scope.hasResults = function(){
			return $scope.userdata.length > 0;
		};

		$scope.isValid = function(){
			return !($scope.responsible.responsible_email === undefined && ((typeof ($scope.responsible.user_id) === 'undefined' || $scope.responsible.user_id < 1)));

		};
		
		$scope.close = function() {
			$mdDialog.cancel();
		};

		$scope.save = function(){
			if($scope.isValid()){
				$mdDialog.hide($scope.responsible);
			}
		};
	}
	
}